import api from './api';

export async function getSalePriceTypes(pointOfSaleId, activeOnly = false) {
  const response = await api.get('/ventas/sale-price-types', {
    params: {
      point_of_sale_id: pointOfSaleId,
      ...(activeOnly ? { active_only: 1 } : {}),
    },
  });
  return response.data;
}

export async function createSalePriceType(payload) {
  const response = await api.post('/ventas/sale-price-types', payload);
  return response.data;
}

export async function updateSalePriceType(id, payload) {
  const response = await api.put(`/ventas/sale-price-types/${id}`, payload);
  return response.data;
}

export async function deleteSalePriceType(id) {
  const response = await api.delete(`/ventas/sale-price-types/${id}`);
  return response.data;
}

export default {
  getSalePriceTypes,
  createSalePriceType,
  updateSalePriceType,
  deleteSalePriceType,
};
